"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.marginFragment = void 0;
exports.marginFragment = `
  fragment margin on Margin {
    id
    timestamp
    discountValue
    importerDiscountValue
    marginValue
    campaignDiscount
    campaignImporter
    marginPercentage
    campaignDiscountPercentage
    campaignImporterPercentage
  }
`;
//# sourceMappingURL=margin.js.map